/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_TopsInputs */

const en_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tops`)
};

const es_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partes de arriba`)
};

const fr_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauts`)
};

const de_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberteile`)
};

const ja_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップス`)
};

const zh_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上衣`)
};

const ar_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلايز (قطعة علوية)`)
};

const id_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atasan`)
};

const it_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top / Sopra`)
};

const ru_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верх`)
};

const pt_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partes de Cima`)
};

const ko_val_tops = /** @type {(inputs: Val_TopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상의`)
};

/**
* | output |
* | --- |
* | "Tops" |
*
* @param {Val_TopsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_tops = /** @type {((inputs?: Val_TopsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_TopsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_tops(inputs)
	if (locale === "es") return es_val_tops(inputs)
	if (locale === "fr") return fr_val_tops(inputs)
	if (locale === "de") return de_val_tops(inputs)
	if (locale === "ja") return ja_val_tops(inputs)
	if (locale === "zh") return zh_val_tops(inputs)
	if (locale === "ar") return ar_val_tops(inputs)
	if (locale === "id") return id_val_tops(inputs)
	if (locale === "it") return it_val_tops(inputs)
	if (locale === "ru") return ru_val_tops(inputs)
	if (locale === "pt") return pt_val_tops(inputs)
	return ko_val_tops(inputs)
});